import React, { useEffect, useState } from "react";
import { Grid } from "@mui/material";
import "../../../Category/categoryProd/components/product.css";
import { ProductCard, Toast } from "components/ui";
import { useLocation } from "react-router-dom";
import { useGlobalContext } from "context/GlobalContext";
import useProductInCatalogCheck from "hooks/useProductInCatalogCheck";
import { useDispatch, useSelector } from "react-redux";
import { initEditCategory, removeEditCategory } from "store/cartSlice";

const SingleProduct = React.memo(({ product, allData }) => {
  const location = useLocation();
  const innerChnages = location?.state?.innerChnages;
  const isRestricted = location?.state?.isRestricted;
  const [btnTitle, setBtnTitle] = useState("Select");

  const isSelectedForEdit = useSelector((state) =>
    state.editCategory.data.some(
      (item) => item.styleNumber === product.styleNumber
    )
  );

  const [open, setOpen] = useState(false);
  const { setCountCart, countCart, setIsEditCatagoryData } = useGlobalContext();

  const dispatch = useDispatch();

  const markCategoryUnRestrict = React.useCallback(() => {
    setBtnTitle("Selected");
    setOpen(true);
  }, [setBtnTitle]);

  const markCategoryRestrict = React.useCallback(
    (productToRemove) => {
      setBtnTitle("Select");
        
            dispatch(
              removeEditCategory({
                storageKey: "RestrictDesign",
                id: productToRemove.id || productToRemove._id,
              })
            );
    },
    [dispatch, setBtnTitle]
  );

  const selectedCartProducts = React.useMemo(
    () => ({
      ...product,
      isAddedInCart: true,
    }),
    [product]
  );

  const handleClose = React.useCallback((reason) => {
    if (reason === "clickaway") return;
    setOpen(false);
  }, []);

  // useEffect(()=>{
  //   setBtnTitle("Select");
  // },[]);

  // useEffect(() => {
  //   setBtnTitle("Select");
  // }, [innerChnages, isRestricted]);

  useEffect(() => {
        if (isSelectedForEdit) {
          setBtnTitle("Selected");
        } else {
          setBtnTitle("Select");
        }
        return;      
    }, [isSelectedForEdit, setBtnTitle]);

  useEffect(() => {
      dispatch(initEditCategory("RestrictDesign"));
    }, [dispatch]);

  return (
    <>
      <Grid item className="product">
        <ProductCard
          data={product}
          selectedCartProducts={selectedCartProducts}
          style={{ maxWidth: "474px", minWidth: "474px" }}
          {...(innerChnages && {
            isBtn: true,
            addtoCart: markCategoryUnRestrict,
            removeCart: markCategoryRestrict,
            btnTilte: btnTitle,
            updateCatagoryData: "RestrictDesign",
          })}
          allData={allData}
          disableContextMenu={true}
        />

        {/* <Toast
          open={open}
          msg={`Design Has Been Added To Cart ${countCart} `}
          autoHideDuration={2000}
          onClose={handleClose}
          anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
          ContentProps={{
            sx: { backgroundColor: "#50C878" },
          }}
        /> */}
      </Grid>
    </>
  );
});

export default React.memo(SingleProduct);
